import { LitElement, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import '../../components/screen.wc.js';

@customElement('ja-home')
export class HomeScreen extends LitElement {
  static styles = css`
    :host {
      display: block;
      font-family: var(--font-body);
    }

    .hero {
      text-align: center;
      padding: 24px 0 16px;
    }

    .brand-logo {
      width: 96px;
      height: 96px;
      object-fit: contain;
      margin-bottom: 8px;
      filter: drop-shadow(0 4px 12px rgba(255, 102, 0, 0.25));
    }

    h1 {
      font-family: var(--font-heading);
      font-size: 1.6rem;
      margin: 0;
      color: var(--text-main, #F5F5F5);
      font-weight: 900;
    }
    h3 {
      font-family: var(--font-heading);
      font-weight: 800;
    }
    p.sub { color: var(--text-muted, #A0A0A0); font-size: 0.9rem; margin-top: 4px; }

    .card {
      background-color: var(--bg-card, #1E1E1E);
      border: 1px solid #2B2B2B;
      border-radius: 12px;
      padding: 20px;
      margin-bottom: 20px;
    }

    .about-card {
      display: flex;
      gap: 16px;
      align-items: center;
    }

    .about-avatar {
      width: 64px;
      height: 64px;
      border-radius: 50%;
      object-fit: cover;
      border: 2px solid var(--accent-orange, #FF6600);
      flex-shrink: 0;
    }

    .about-content h3 {
      margin: 0 0 4px 0;
      font-size: 1rem;
      color: var(--text-main, #F5F5F5);
    }

    .about-content p {
      margin: 0;
      color: var(--text-muted, #A0A0A0);
      font-size: 0.85rem;
      line-height: 1.4;
    }

    .tag {
      display: inline-block;
      background: rgba(255, 102, 0, 0.15);
      color: var(--accent-orange, #FF6600);
      font-size: 0.75rem;
      font-weight: 600;
      padding: 4px 8px;
      border-radius: 4px;
      margin-bottom: 8px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .input-box {
      width: 100%;
      padding: 12px;
      margin-top: 12px;
      background-color: #121212;
      border: 1px solid #333;
      border-radius: 6px;
      color: #FFF;
      box-sizing: border-box;
    }

    .btn-orange {
      width: 100%;
      padding: 12px;
      margin-top: 10px;
      background-color: var(--accent-orange, #FF6600);
      border: none;
      border-radius: 6px;
      color: #FFF;
      font-weight: bold;
      cursor: pointer;
    }

    .section-title {
      font-family: var(--font-heading);
      font-size: 1.1rem;
      font-weight: 800;
      color: var(--text-main, #F5F5F5);
      margin: 24px 0 12px;
    }

    .product-card {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--bg-card, #1E1E1E);
      border: 1px solid #2B2B2B;
      border-radius: 8px;
      padding: 14px;
      margin-bottom: 10px;
      text-decoration: none;
      color: inherit;
    }

    .product-info h3 {
      font-size: 0.95rem;
      margin: 0;
      color: #FFF;
    }

    .product-info p {
      font-size: 0.8rem;
      color: #A0A0A0;
      margin: 2px 0 0;
    }

    .price {
      font-weight: bold;
      color: var(--accent-orange, #FF6600);
      font-size: 1rem;
    }
  `;

  render() {
    return html`
      <ja-screen>
        <div class="scroll-content">
          <div class="hero">
            <img src="/assets/logo/logo.svg" alt="javi.adv logo" class="brand-logo" />
            <h1>javi.adv</h1>
            <p class="sub">Heavy ADV & Hard Enduro Trail Notes</p>
          </div>

          <div class="card">
            <span class="tag">Uníte a la comunidad</span>
            <h3>Descarga la guía básica de off-road</h3>
            <p style="color: #A0A0A0; font-size: 0.85rem; line-height: 1.4;">
              Recibe además tips de manejo, guías de configuración para tu moto, rutas recomendadas y contenido exclusivo para los que les gusta el off-road. Sin spam, solo contenido útil.
            </p>
            <form @submit=${this._handleSubscribe}>
              <input type="email" class="input-box" placeholder="Tu dirección de correo" required />
              <button type="submit" class="btn-orange">Unírse</button>
            </form>
          </div>

          <div class="card about-card">
            <img src="/assets/logo/javiadv.png" alt="Javi ADV Avatar" class="about-avatar" />
            <div class="about-content">
              <h3>¿Quién está detrás de javi.adv?</h3>
              <p>
                Entusiasta enfocado en Heavy ADV (T7) y Hard Enduro (KTM 300). Comparto rutas probadas en terreno real y ajustes técnicos sin mucho blah blah
              </p>
            </div>
          </div>

          <div class="section-title">One-Time GPX & Digital Drops</div>

          <a href="/store" class="product-card">
            <div class="product-info">
              <h3>🗺️ Rutas para iniciar en ADV Enduro</h3>
              <p>Rutas técnicas probadas. Incluye ruta, lugares de comer, puntos de interes y recomendaciones para principiantes.</p>
            </div>
            <div class="price">$9.99</div>
          </a>

          <!-- <a href="/store" class="product-card">
            <div class="product-info">
              <h3>⚙️ Setup de mi T7</h3>
              <p>Accesorios para hacer la moto más cómoda y funcional. Con proveedores y precios aproximados.</p>
            </div>
            <div class="price">$9.99</div>
          </a> -->
        </div>
      </ja-screen>
    `;
  }

  private _handleSubscribe(e: Event) {
    e.preventDefault();
    alert('Welcome to the inner circle!');
  }
}